exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zahlungentabs .nav-tabs{padding-left:18px;margin-top:10px;margin-left:-8px;margin-right:-8px}.zahlungen-list-view__betroffene{padding:30px 150px}@media(min-width:992px){.zahlungentabs{margin-left:10px;margin-right:10px}.zahlungentabs .nav-tabs{padding-left:245px;margin-top:27px}.zahlungentabs .tab-pane{padding-left:30px;padding-right:30px;padding-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/zahlungen/zahlungen.module.scss
// module id = mhZf
// module chunks = 0